'use client';

import React from 'react';
import Image from 'next/image';
import { useRouter, usePathname } from 'next/navigation';
import styles from './BottomNav.module.css';
import { useTranslation } from 'react-i18next';

const BottomNav: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { t } = useTranslation();

  const navItems = [
    {
      id: 'play',
      label: t('PLAY'),
      icon: '/bottom-nav/play.svg',
      path: '/dashboard',
    },
    {
      id: 'leaderboard',
      label: t('LEADERBOARD'),
      icon: '/bottom-nav/leaderboard.svg',
      path: '/leaderboard',
    },
    {
      id: 'results',
      label: t('RESULTS'),
      icon: '/bottom-nav/results.svg',
      path: '/results',
    },
    {
      id: 'rewards',
      label: t('REWARDS'),
      icon: '/bottom-nav/rewards.svg',
      path: '/rewards',
    },
  ];

  const handleNavClick = (path: string) => {
    router.push(path);
  };

  return (
    <nav className={styles.bottomNav}>
      {navItems.map(item => (
        <button
          key={item.id}
          className={`${styles.navItem} ${pathname === item.path || (item.id === 'play' && pathname.startsWith('/') && !pathname.startsWith('/leaderboard') && !pathname.startsWith('/results') && !pathname.startsWith('/rewards') && !pathname.startsWith('/admin')) ? styles.active : ''}`}
          onClick={() => handleNavClick(item.path)}
        >
          <Image
            src={item.icon}
            alt={`${item.label} icon`}
            className={styles.navIcon}
            width={40}
            height={40}
          />
          <span className={styles.navLabel}>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
